<template>
    <v-dialog v-model="invitemodal" persistent max-width="300px">
        <template v-slot:activator="{ on }">
            <div class="action" v-on="on">
                <font-awesome-icon class="adduser" icon="plus-circle"/><p>Invite User</p>
            </div>
        </template>
        <v-card class="modal">
            <v-card-title class="modal">Invite Users</v-card-title>
            <v-card-text class="modal">
                <div v-if="this.team_id == undefined || this.team_id == ''">
                  <p>Please select a team first.</p>
                </div>
                <div v-else>
                  <p>Type in emails separated by comma.</p>
                  <textarea id="message" rows="10" v-model="inviteemails" required></textarea>
                  <span style="color: #2bb9aa" v-if="status.success == true">{{status.msg}}</span>
                  <span style="color: red" v-else>{{status.msg}}</span>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-btn small class="save" @click="inviteUsers" v-if="this.team_id != undefined && this.team_id != ''">Invite</v-btn>
                <v-btn small class="cancel" @click="invitemodal = false">Cancel</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: ['team_id'],
    data() {
      return {
        invitemodal: false,
        inviteemails: '',
        status: {
          success: false,
          msg: ''
        }
      }
    },

    methods: {
      inviteUsers() {
        const data = {
          email: this.inviteemails,
          team_id: this.team_id
        };
        this.status = {
          success: true,
          msg: "Sending..."
        };
        this.$store.dispatch("inviteUsers", data)
          .then(() => {
            this.status = {
              success: true,
              msg: "Invite has been sent successfully"
            };
          })
          .catch(error => {
            this.status = {
              success: false,
              msg: error.data.error
            };
          });
      }
    }
    
}
</script>